/* RESPONSIBLE TEAM: team-standalone */
import { default as BaseChannelsController } from 'embercom/controllers/apps/app/standalone/channels/base-channels';

export default class FinStandaloneSalesforceCasesController extends BaseChannelsController {}
